import type { SessionSummary } from '@/src/dal/session-dal'

export function selectVoiceAssessmentSessions(
  sessions: readonly SessionSummary[] | undefined,
  sessionDefinitionIds: readonly number[],
): SessionSummary[] {
  if (sessions == null || sessionDefinitionIds.length === 0) {
    return []
  }

  const definitionIds = new Set(sessionDefinitionIds)
  return sessions
    .filter((session) => definitionIds.has(session.definition.id))
    .sort((a, b) => b.created.getTime() - a.created.getTime())
}
